export const selectCreditData = (state) => state.credit.data;
export const selectCreditStatus = (state) => state.credit.status;
export const selectCreditError = (state) => state.credit.error;